<template>
  <div class="white-panel">
    <p class="h4 lora mb-3">Podsumowanie rezerwacji!</p>

    <div class="row item-row">
      <div class="col">
        od:
        <b>{{ formatDate(schema.dateRange.start, '16:00') }}</b>
        <br />do:
        <b>{{ formatDate(schema.dateRange.end, '11:00') }}</b>
      </div>
    </div>

    <div class="row item-row">
      <div class="col">
        {{ schema.offer.name.$value }}<br /><small v-html="schema.offer.description.$value"></small>
      </div>
    </div>

    <div
      v-for="(occupancy, occupancyIndex) in schema.occupancy.$items"
      :key="'sum_oc_' + occupancyIndex"
      class="row item-row"
    >
      <div class="col">
        {{ occupancy.$item.room.name.$model }}
        <span v-if="occupancy.$item.numberOfAdults.$value">
          <br />Osoby dorosłe: {{ occupancy.$item.numberOfAdults.$value }}
        </span>

        <span v-if="occupancy.$item.numberOfChildren3.$value">
          <br />Dzieci do lat 3: {{ occupancy.$item.numberOfChildren3.$value }}
        </span>

        <span v-if="occupancy.$item.numberOfChildren12.$value">
          <br />Dzieci 4-12 lat: {{ occupancy.$item.numberOfChildren12.$value }}
        </span>
        <div v-if="occupancy.$item.additions.$items.length">
          Dodatki:
          <ul class="list-inline">
            <li
              v-for="(addition, additionIndex) in occupancy.$item.additions.$items"
              :key="'addition_' + additionIndex"
            >
              {{ addition.$item.name.$model }}
            </li>
          </ul>
        </div>

        <div class="row">
          <div class="col-9">Pełny koszt:</div>
          <div class="col-3 text-right">{{ formatPrice(occupancy.$item.priceTotal.$model) }}</div>
        </div>
      </div>
    </div>

    <div class="row item-row">
      <div class="container-fluid">
        <div class="row suma">
          <div class="col-9">
            <b>SUMA:</b>
          </div>
          <div class="col-3 text-right">
            <b>{{ formatPrice(schema.priceTotal.$model) }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
dayjs.locale('pl');

import { formatPrice } from '@/utils/formatPrice';

export default {
  props: {
    schema: { type: Object, required: true }
  },
  methods: {
    formatDate(date, hour) {
      return dayjs(date.$model).format(`dddd, DD.MM.YYYY, ${hour}`);
    },
    formatPrice
  }
};
</script>
